import * as React from 'react';

import { cn } from '@rematter/ui-web';

export interface LineItemFooterProps {
  gridTemplate: string;
  children: React.ReactNode;
  className?: string;
}

export const LineItemFooter: React.FC<LineItemFooterProps> = ({
  gridTemplate,
  children,
  className,
}) => (
  <div
    className={cn('@LineItemFooter grid gap-2 pt-2', gridTemplate, className)}
  >
    {children}
  </div>
);

export interface FooterCellProps {
  children?: React.ReactNode;
  className?: string;
}

export const FooterCell: React.FC<FooterCellProps> = ({
  children,
  className,
}) => <div className={cn('@FooterCell flex', className)}>{children}</div>;
